export default __webpack_public_path__ + "static/media/sales-analytics-2.a13ac75d.svg";